import React, { useState } from "react";
import "./FormContactarGrupalList.scss";
import Button from "../../atoms/button/button";
import FormContactarGrupal from "../form-contactar-grupal/FormContactarGrupal";
import useBrowserMode from "../../../shared/hooks/useBrowserMode";
import { wordFixerForGTM } from "../../../shared/utils/stringUtilities"

interface ContactarGrupalListProps {
    listSelectedTalents: any;
    setListSelectedTalents: any;
    setIsDisabledForProhibited: any;
    messageTalent: any;
    setActivateToast: any;
}

const FormContactarGrupalList = (props: ContactarGrupalListProps ) => {
    const {
        listSelectedTalents,
        setListSelectedTalents,
        setIsDisabledForProhibited,
        messageTalent,
        setActivateToast
    } = props;

    const [isEliminationProcess, setIsEliminationProcess] = useState<boolean>(false);
    const [isProhibited, setIsProhibited] = useState<boolean>(false);
    const [indexHelper, setIndexHelper] = useState(0);
    const [allowList, setAllowList] = useState<boolean>(true);
    const { isBrowser } = useBrowserMode();
    const pathName = isBrowser ? window.location.pathname: '';
    const [profession, setProfession] = useState<string>('');

    const handleDelete = (index) => {
        const updatedArray = [...listSelectedTalents];
        if(updatedArray.length === 1){
            setIsProhibited(true);
        }else{
            updatedArray.splice(index, 1);
            setListSelectedTalents(updatedArray);
            localStorage.setItem(
                "talentsSelected",
                JSON.stringify(updatedArray)
            );
            setIsEliminationProcess(false);
            setAllowList(true);
            setActivateToast(true);
            changeToastState;
        }
    };

    const changeToastState = setTimeout(() => {
        setActivateToast(false);
    }, 3000);

    const nameAndLastNameFixed = (nombres, apellidos) => {
        
        const name = nombres.toLowerCase().split(' ');
        const nameFixed = name.map(name => name.charAt(0).toUpperCase() + name.slice(1));

        const lastName = apellidos.toLowerCase().split(' ');
        const lastNameFixed = lastName.map(lastName => lastName.charAt(0).toUpperCase() + lastName.slice(1));

        return nameFixed.join(" ") + " " + lastNameFixed.join(" ");
    }

    const dataForList = (selectedTalent, index) => {
        return  ( <FormContactarGrupal 
                        fullName={nameAndLastNameFixed(selectedTalent.nombres, selectedTalent.apellidos)}
                        index={index}
                        setIndexHelper={setIndexHelper}
                        setAllowList={setAllowList}
                        setIsProhibited={setIsProhibited}
                        setIsEliminationProcess={setIsEliminationProcess}
                        listSelectedTalents={listSelectedTalents}
                        setIsDisabledForProhibited={setIsDisabledForProhibited}
                        setProfession={setProfession}
                        professionHelper={wordFixerForGTM(selectedTalent.nivelEducativo?.map(i => i.tituloProfesional).toString())}
                    />
                );
    }

    return (
        <div className="m-form-contactar-grupal-list">
            {allowList && listSelectedTalents.length > 0 && (
                listSelectedTalents.map((selectedTalent, index) =>
                    dataForList(selectedTalent, index)
                )
            )}
            {isEliminationProcess && (
                <div className={`m-form-contactar-grupal-list__advertisement`}>
                    <div className="m-form-contactar-grupal-list__advertisement__message">
                        <h3>{messageTalent[0].tituloBanner}</h3>
                    </div>
                    <div className="m-form-contactar-grupal-list__advertisement__message__button">
                        <Button
                            onClickAction={() => {
                                handleDelete(indexHelper)
                            }}
                            type="button"
                            text={messageTalent[0].tituloBoton}
                            classname={`a-button__magenta dimensions gtm_${pathName.split('/')[3]}_eliminar_seleccionado_${profession}`}
                            id={wordFixerForGTM(profession)}
                            isDisabled={false}
                        />

                        <Button
                            onClickAction={() => {
                                setIsEliminationProcess(false);
                                setAllowList(true);
                                setIsDisabledForProhibited(false);
                            }}
                            type="button"
                            text={'CANCELAR'}
                            classname={`a-button cancel-dimensions`}
                            isDisabled={false}
                        />
                    </div>
                </div>
            )} 
            {isProhibited && (
                <div className="m-form-contactar-grupal-list__advertisement">
                    <div className="m-form-contactar-grupal-list__advertisement__message prohibited">
                        <h3>{messageTalent[1].tituloBanner}</h3>
                    </div>
                    <div className="m-form-contactar-grupal-list__advertisement__message__button">
                        <Button
                            onClickAction={() => {
                                setIsProhibited(false);
                                setAllowList(true)
                            }}
                            type="link"
                            text={messageTalent[1].tituloBoton}
                            classname={`a-button__magenta prohibited-dimensions`}
                            isDisabled={false}
                            href=".."
                        />

                        <Button
                            onClickAction={() => {
                                setIsProhibited(false);
                                setAllowList(true);
                                setIsDisabledForProhibited(false);
                            }}
                            type="button"
                            text={'CANCELAR'}
                            classname={`a-button cancel-dimensions`}
                            isDisabled={false}
                        />
                    </div>
                </div>
            )}
        </div>
    );
};
export default FormContactarGrupalList;
